import React, { useEffect, useRef, useState } from "react";
import { createChart } from "lightweight-charts";

const TradingViewChart = ({ initialData, liveData }) => {
  const chartContainerRef = useRef(null);
  const chartRef = useRef(null);
  const candleSeriesRef = useRef(null);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (initialData && initialData.length > 0) {
      const formattedInitialData = initialData
        .map((item) => ({
          ...item,
          time: Math.floor(item.time / 1000), // Convert milliseconds to seconds
          formattedTime: new Date(item.time).toLocaleString(), // Full date & time
        }))
        .sort((a, b) => a.time - b.time); // Ensure ascending order

      setChartData(formattedInitialData);
    }
  }, [initialData]);

  useEffect(() => {
    const chart = createChart(chartContainerRef.current, {
      width: chartContainerRef.current.clientWidth,
      height: 400,
      layout: {
        backgroundColor: "#ffffff",
        textColor: "#000000",
      },
      grid: {
        vertLines: {
          color: "#eeeeee",
        },
        horzLines: {
          color: "#eeeeee",
        },
      },
      priceScale: {
        borderColor: "#cccccc",
      },
      timeScale: {
        borderColor: "#cccccc",
        timeVisible: true,
        secondsVisible: true,
        rightOffset: 5,
      },
    });

    // Add the candle series with a custom price format
    const candleSeries = chart.addCandlestickSeries({
      upColor: "green",
      downColor: "red",
      borderVisible: false,
      wickUpColor: "green",
      wickDownColor: "red",
      priceFormat: {
        type: "price",
        precision: 12, // Number of decimal places to display
        minMove: 0.000000000001, // Smallest price movement
      },
    });

    // Store references
    chartRef.current = chart;
    candleSeriesRef.current = candleSeries;

    if (chartData && chartData.length > 0) {
      candleSeries.setData(chartData);
    }

    return () => {
      chart.remove();
    };
  }, [chartData]);

  useEffect(() => {
    if (liveData?.length > 0) {
      setChartData((prevData) => {
        const lastClose = prevData.length > 0 ? prevData[prevData.length - 1].close : null;

        const updatedLiveData = liveData
          .map((item, index) => ({
            ...item,
            time: Math.floor(item.time / 1000),
            formattedTime: new Date(item.time).toLocaleString(),
            open: (index === 0 && lastClose !== null ? lastClose : liveData[index - 1]?.close || item.open),
          }))
          .sort((a, b) => a.time - b.time);

        return [...prevData, ...updatedLiveData].sort((a, b) => a.time - b.time);
      });
    }
  }, [liveData]);

  useEffect(() => {
    if (candleSeriesRef?.current) {
      candleSeriesRef?.current?.setData(chartData);
    }
  }, [chartData, liveData]);

  return (
    <div
      ref={chartContainerRef}
      style={{ position: "relative", width: "100%", height: "100%" }}
    />
  );
};

export default TradingViewChart;